export const OpenAvaniShop = (): void => {
  const newWindow = window.open('https://www.avanisolutions.co.uk/shop/', '_blank', 'noopener,noreferrer');

  if (newWindow) newWindow.opener = null;
};
